import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Custom validator for key fields.
 * Ensures the value is all lowercase, has no whitespace, no special characters, and is unique.
 * @returns Validator function that checks the control value.
 */
export function usernameValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    return validateUsernameValue(value);
  };
}
export function validateUsernameValue(value: string) {
  let errors: ValidationErrors = {};

  if (!value) {
    return null;
    errors = { ...errors, ...{ required: true } };
  }

  // Check for lowercase letters only
  if (value !== value.toLowerCase()) {
    errors = { ...errors, ...{ lowercaseRequired: true } };
  }

  // Check for no whitespaces
  if (/\s/.test(value)) {
    errors = { ...errors, ...{ whitespaceNotAllowed: true } };
  }

  // Check for no special characters (only allow alphanumeric)
  if (/[^a-z0-9_@\.\-]/.test(value)) {
    errors = { ...errors, ...{ noSpecialCharsAllowed: true } };
  }

  return Object.keys(errors).length ? errors : null;
}
